import { GlobalHelperFunctions } from '../../../../utils/GlobalHelperFunctions';
import './style.scss';
export default class VNextAnalyticsPanel extends UIObject {
  mDiv: JQuery<HTMLElement>;
  timeCreated: number;
  mData: any;
  mSubNavigation: any;

  private _constructorParams: any;
  constructor() {
    super();
  }

  initialize(aConstructorParams: any) {
    this._constructorParams = aConstructorParams;
    this.mDiv = this._generateHtml();
    $('#screens').prepend(this.mDiv);
    this._buildSettings();
    this.setupSubNav();
  }

  private _generateHtml(): JQuery<HTMLElement> {
    return $(
      HGEN.tree({
        id: 'vnext_analytics_panel',
        children: [
          { style: 'subnav_container ui_full_width subnav-font-family' },
          {
            id: 'juno_vnext_analytics',
            style: 'vnext_learning_container',
          },
        ],
      }),
    );
  }

  private _getLiveAnalytics() {
    var self = this;
    var aUrl = 'custom_api/api_analytics_getLiveVnext.php';
    var aVars = {};
    aVars.display = 'ALL';
    aVars.token = App.INSTANCE.CurrentUser.Token;

    App.INSTANCE.mApi.Request(
      CrowdHub_App.CONFIG.BASE_URL + aUrl,
      aVars,
      function (aData) {
        if (aData.success == 'true') {
          aData.getSiteChannel = function () {
            return PubNubCenter.INSTANCE?.getSiteChannel();
          };
          self.mData.vNowLiveAnalytics = aData;
          if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
            console.info(aData);
          }
        } else {
          console.error(aData);
        }
      },
      function (aData) {
        console.error(aData);
      },
    );
  }

  private _buildSettings(): void {
    const defaultWidgetProps = App.INSTANCE.defaultVNextWidgetProps();

    /* leon doesn't know why these were here
    window.onpopstate = function (e) {
      // need to manually reload when back button is pressed to the initial state
      if (e.state.idx === 0) {
        location.reload();
      }
    };
*/

    this.timeCreated = Date.now();
    this.mData = {
      // todo: pare down this config object to just a theme
      ...defaultWidgetProps,
      excludedCategories: CrowdHub_App.CONFIG.ANALYTICS_WIDGETS_EXCLUDED_CATEGORIES || [],
      reportableTags: this._constructorParams.reportableTags,
      junoUserId: App.INSTANCE.CurrentUser.Id,
      junoPlatformId: window.PLATFORM_DATA?.Platform?.Id,
      routing: {
        route: function (bucket, slug, tag) {
          var aUrl;
          switch (bucket) {
            case CrowdHub_App.BUCKET_ID_PARTNER:
              aUrl = App.INSTANCE.appRouter.generate('navigate.partner.slug', { slug: slug });
              break;
            case CrowdHub_App.BUCKET_ID_LIBRARY:
              aUrl = App.INSTANCE.appRouter.generate('navigate.library.slug', { slug: slug });
              break;
            case CrowdHub_App.BUCKET_ID_OTSESSION:
              switch (tag) {
                case CrowdHub_App.TAGID_MAINEVENT:
                  aUrl = App.INSTANCE.appRouter.generate('navigate.mainstage.slug', { slug: slug });
                  break;
                case CrowdHub_App.TAGID_BREAKOUT:
                  aUrl = App.INSTANCE.appRouter.generate('navigate.breakout.slug', { slug: slug });
                  break;
                case CrowdHub_App.TAGID_PANEL:
                  aUrl = App.INSTANCE.appRouter.generate('navigate.panel.slug', { slug: slug });
                  break;
              }
              break;
            default:
              aUrl = App.INSTANCE.appRouter.generate('navigate.breakout.slug', { slug: slug });
              break;
          }
          if (aUrl) {
            App.INSTANCE.route(aUrl);
          } else {
            console.error(`Unable to determine route for ${slug}`);
          }
        },
      },
    };
    this._getLiveAnalytics();

    window.JunoWidgetSettings = window.JunoWidgetSettings || {};
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
    window.JunoWidgetSettings.widgets.push({
      siteId: CrowdHub_App.CONFIG.VNEXT_SITE_ID,
      widget: 'juno_analytics_examine',
      mount: 'juno_vnext_analytics',
      data: this.mData,
      timeCreated: this.timeCreated,
    });

    const newScript = document.createElement('script');
    newScript.src = CrowdHub_App.CONFIG.VNEXT_WIDGET_SCRIPT_SRC || `https://widgets.junolive.dev/junoWidgets.js`;
    this.mDiv.append(newScript);
  }

  private setupSubNav(): void {
    if (this.mData.showSubNav == true && this.mData.subNavItems != null && this.mData.subNavItems.length > 0) {
      this.mSubNavigation = new CustomSubNavigation();
      this.mSubNavigation.initialize({ items: this.mData.subNavItems, div: this.mDiv.find('.subnav_container') });
    }
  }

  onTransitionOut(): void {
    const widgetKey = 'juno_analytics_examine';
    window.JunoWidgetSettings = window.JunoWidgetSettings || {};
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
    const matchesWidget = widget => widget.widget === widgetKey && widget.timeCreated === this.timeCreated;
    const selectedWidget = window.JunoWidgetSettings.widgets.find(widget => matchesWidget(widget));
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets.filter(widget => !matchesWidget(widget));
    selectedWidget?.reactRoot?.unmount();
  }
}
